import * as React from 'react';

import { Box } from '@lightspeed/flame/Core';

import { LoadError } from '../ReorderPoints/LoadError';
import { OverlayDiv } from '../ReorderPoints/ReorderPoints.style';

type Props = {
  onReload: () => void;
};

export const ErrorState: React.FC<Props> = ({ onReload }) => {
  return (
    <Box
      style={{
        background: '#f8f8f8',
        borderBottom: '1px solid #eee',
        margin: '-3px -5px 0',
        fontSize: '12px',
        padding: '40px 0',
        position: 'relative',
      }}
    >
      <OverlayDiv>
        <LoadError rowCount={3} onReload={onReload} />
      </OverlayDiv>
    </Box>
  );
};
